/*!
 * STM Robotics - WhatsApp Click Tracker
 * ----------------------------------------------------------
 * Captura atribucion de Meta/Google (fbclid, gclid, utm_*) y pagina de origen,
 * la guarda en localStorage por 30 dias.
 *
 * Version: 1.0.1 - 2026-06-17 - buildTag() neutralizado: ya NO inyecta [ref] visible
 * al mensaje de WhatsApp (decision de Juan). La captura sigue activa por si se
 * reactiva una atribucion no visible mas adelante. Original v1.0.0 respaldado.
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'stm_attr';
  var TTL_DAYS = 30;
  var MAX_FBCLID_LEN = 32;
  var MAX_GCLID_LEN = 32;
  var MAX_UTM_LEN = 80;

  function nowMs() { return new Date().getTime(); }

  function readAttr() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t) return null;
      if (nowMs() - obj.t > TTL_DAYS * 24 * 60 * 60 * 1000) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return obj.v || null;
    } catch (e) { return null; }
  }

  function writeAttr(v) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ t: nowMs(), v: v }));
    } catch (e) {}
  }

  function sanitize(s, max) {
    return String(s || '').replace(/[\[\]]/g, '').slice(0, max || MAX_UTM_LEN);
  }

  function pageHandle() {
    try {
      var p = (location.pathname || '/').replace(/\/+$/, '');
      var seg = p.split('/').pop() || 'home';
      return sanitize(seg, 40);
    } catch (e) { return 'home'; }
  }

  function capture() {
    var sp;
    try { sp = new URL(location.href).searchParams; } catch (e) { return; }

    var current = readAttr() || {};
    var captured = false;

    function setIfPresent(key, paramName) {
      var v = sp.get(paramName);
      if (v) { current[key] = sanitize(v, MAX_UTM_LEN); captured = true; }
    }

    setIfPresent('c', 'utm_campaign');
    setIfPresent('a', 'utm_content');
    setIfPresent('m', 'utm_medium');
    setIfPresent('s', 'utm_source');
    setIfPresent('t', 'utm_term');

    var fbclid = sp.get('fbclid');
    if (fbclid) { current.f = sanitize(fbclid, MAX_FBCLID_LEN); captured = true; }

    var gclid = sp.get('gclid');
    if (gclid) { current.g = sanitize(gclid, MAX_GCLID_LEN); captured = true; }

    if (captured && !current.fst) {
      current.fst = new Date().toISOString().slice(0, 10);
    }

    if (captured) writeAttr(current);
  }

  // [ref ...] visible DESACTIVADO 2026-06-17 (decision Juan): no inyectar tag al mensaje.
  // Se conserva la captura de atribucion; para reactivar, restaurar el cuerpo original (backup v1.0.0).
  function buildTag(attr, pHandle) {
    return '';
  }

  function rewriteHref(href) {
    try {
      var fullUrl = href.indexOf('://') === -1 ? 'https://' + href : href;
      var u = new URL(fullUrl);
      var host = (u.hostname || '').toLowerCase();
      var isWA = (host === 'wa.me' || host === 'api.whatsapp.com' || host === 'web.whatsapp.com');
      if (!isWA) return null;

      var attr = readAttr() || {};
      var tag = buildTag(attr, pageHandle());
      if (!tag) return null;

      var existingText = u.searchParams.get('text') || '';
      if (existingText.indexOf('[ref ') !== -1) return null;

      var newText = existingText ? (existingText + tag) : ('Hola, me interesa cotizar' + tag);
      u.searchParams.set('text', newText);
      return u.toString();
    } catch (e) { return null; }
  }

  function onClick(e) {
    var t = e.target;
    if (!t) return;
    var a = (t.closest && t.closest('a[href]')) || null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/wa\.me|api\.whatsapp\.com|web\.whatsapp\.com/i.test(href)) return;

    var rewritten = rewriteHref(href);
    if (rewritten) a.setAttribute('href', rewritten);
  }

  function init() {
    capture();
    document.addEventListener('click', onClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
